export class TagKeysCondition {
    'operator';
    'tagKeys';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ListOperators",
            "format": ""
        },
        {
            "name": "tagKeys",
            "baseName": "tagKeys",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TagKeysCondition.attributeTypeMap;
    }
    constructor() {
    }
}
